export const imageNames = [
  "document-biz_treasure.png",
  "bargraph-biz_treasure.png",
  "disk-biz_treasure.png",
  "calculator-biz_treasure.png",
  "clipboard-biz_treasure.png",
  "printer-biz_treasure.png",
  "binder-biz_treasure.png",
  "clock-biz_treasure.png",
  "fileholder-biz_treasure.png",
  "userpass-biz_treasure.png",
  "openmail-biz_treasure.png",
  "mail-biz_treasure.png",
  "piegraph-biz_treasure.png",
  "linegraph-biz_treasure.png",
  "cup-biz_treasure.png",
  "pin-biz_treasure.png",
  "clip-biz_treasure.png",
  "smartphone-biz_treasure.png",
  "telephone-biz_treasure.png",
  "businessbag-biz_treasure.png",
  "calendar-biz_treasure.png",
  "megaphone-biz_treasure.png",
  "pencil-biz_treasure.png",
  "mouse-biz_treasure.png",
  "flash-biz_treasure.png",
  "equipment-biz_treasure.png",
  "wallet-biz_treasure.png",
  "piggybank-biz_treasure.png",
  "creditcard-biz_treasure.png",
  "payment-biz_treasure.png",
  "glasses-biz_treasure.png",
  "soroban-biz_treasure.png",
  "cashbox-biz_treasure.png",
  "diamond-biz_treasure.png",
  "balloon-biz_treasure.png",
  "thinkingballoon-biz_treasure.png",
  "tool-biz_treasure.png",
  "cloudup-biz_treasure.png",
  "gear-biz_treasure.png",
  "lock-biz_treasure.png",
  "chemistry-biz_treasure.png",
  "research-biz_treasure.png",
  "gasstation-biz_treasure.png",
  "percent-biz_treasure.png",
];
